import { addHours, subDays } from 'date-fns'
import { getDayStart } from '../../../redux/thunk/unpaidOrders'
import { CANCELLATION_WINDOW_CASH_DAYS } from '../constants'

const CASH_DAY_MIDDLE_HOURS = 12

export const getOldestCancellationDate = (now) => {
	const currentCashDayStart = getDayStart(now.toISOString())
	const oldestCashDayMiddle = addHours(subDays(currentCashDayStart, CANCELLATION_WINDOW_CASH_DAYS - 1), CASH_DAY_MIDDLE_HOURS)
	return getDayStart(oldestCashDayMiddle.toISOString())
}

export const isTicketOrder = order => !!order?.ticketMetaData

export const isInvoiceOrder = order => !!order?.payments?.some(payment => payment.method === 'INVOICE')

export const isAlreadyCanceledOrder = order => !!(order?.orderCanceledDayCounter || order?.orderCanceledCounter || order?.canceledDate)

export const isClosedShiftPlatformOrder = order => !!order?.zNumber && !!order?.platformMetaData && order.platformMetaData.platformType !== 'ONLINE_SHOP'
